import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useSnackbar } from "notistack";
import { useLoadingScreen } from '../../Store/LoadingManager';
import QueryBuilderHelper from "../../Utilities/Helpers/QueryBuilderHelper";
import { GetCompanyLicenseHistories  } from "../../Api/Service/Company/companyService";
import { useLocation } from "react-router-dom";
import { ErrorMessage, SuccessMessage } from "../../Constants/Messages";

export function useCompanyLicenseHook(q_queryKey: any, params: any, runInitialFetch: boolean = true) {
    let queryClient = useQueryClient();
    // let { id: companyid } = useParams();
    let location = useLocation();
    let queryParams = new URLSearchParams(location.search);
    let companyid = queryParams.get('id') ?? "0";
    let { loading, setLoading } = useLoadingScreen();

    let { enqueueSnackbar } = useSnackbar();
    let fileBaseUrl = `${process.env.REACT_APP_API_URL}/api/`;

    // Initial fetch
    const { data, fetchStatus } = useQuery({
        queryKey: q_queryKey,
        queryFn: () => getCompanyLicenseHistory(params),
        enabled: runInitialFetch,
    });

    const getCompanyLicenseHistory = async (params: any) => {
        let _data;
        const responseData = await GetCompanyLicenseHistories(companyid ?? "", QueryBuilderHelper.BuildQueryString(params));
        if (responseData?.isSuccess) {
            _data = responseData?.data
        } else {
            enqueueSnackbar(responseData?.message ?? (responseData?.data?.message ?? ErrorMessage.PROBLEM_FETCHING_DATA), { variant: 'error' })
        }
        return _data;
    }

    const companyLicenseHistoryInvalidateQueries = async () => {
        queryClient.invalidateQueries(q_queryKey);
        return true;
    }

    return { data, fetchStatus, companyLicenseHistoryInvalidateQueries }
}